<div class="v2-locale-switcher">
  <button
    type="button"
    class="v2-locale-switcher__trigger"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="toggle()">
    <span class="v2-locale-switcher__flag">{{ current?.flag }}</span>
    <span>{{ current?.label }}</span>
  </button>
  <ul class="v2-locale-switcher__menu" role="listbox" *ngIf="isOpen()">
    <li *ngFor="let locale of locales" role="option" [attr.aria-selected]="locale.code === value">
      <button type="button" class="v2-locale-switcher__option" (click)="select(locale.code)">
        <span class="v2-locale-switcher__flag">{{ locale.flag }}</span>
        <span>{{ locale.label }}</span>
      </button>
    </li>
  </ul>
</div>
